const Plugins = () => {
  return (
    <>
      <h2>Plugins</h2>
      <div style={{display: "flex", justifyContent: "center"}}>
        <h6>Under construction.</h6>
      </div>
    </>
  );
};

export default Plugins;